/**
* avatar component for the left side menu
*
* Created by Tom on 25/05/18
*/

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import { ActionCreator } from '../../actions/'

// icon imports
import AvatarIcon from '../../assets/svg/avatar.svg'

// style import
import './style.scss'
import cx from "classnames";


class Avatar extends Component {

    _updateProfileClick(e) {
        const { goToRoute } = this.props
        // do not refresh page
        e.preventDefault();
        e.stopPropagation();
        // go to route
        goToRoute('/account')
    }

    render() {
        const { pathname } = this.props
 
        // TODO: replace fake name with name from API
        const name = 'Thomas Dittmar'
        const dynClass = cx(
            'avatar__info-container',
            {'avatar__info-container--active': '/account' === pathname}
        )

        return (
            <div className="avatar">

                {/* container for the avatar icon, name & link */}
                <div className={dynClass}>

                    <img
                        src={AvatarIcon}
                        className="avatar__info-container__avatar-icon"
                        alt="Avatar icon"
                        onClick={::this._updateProfileClick}
                    />

                    <div className="avatar__info-container__profile-container">
                        <p className="avatar__info-container__avatar-name">{name}</p>
                        <a href="" className="avatar__info-container__profile-container__update"
                            onClick={::this._updateProfileClick}>
                            Update my profile
                        </a>
                    </div>
                </div>

            </div>
        )
    }
}

// define the prop types
Avatar.propTypes = {
    goToRoute: PropTypes.func.isRequired,
    pathname: PropTypes.string
}

// pull props to this container
const mapStateToProps = (state) => {
    return {
        // get the name from store
        pathname: state.router.location.pathname
    }
}

// pull all required action creators into this container
const mapDispatchToProps = (dispatch) => {
    const action = bindActionCreators(ActionCreator, dispatch)
    return {
        goToRoute: action.goToRoute
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Avatar)



// WEBPACK FOOTER //
// ./src/components/Avatar/index.js